import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import SectionHeading from "../components/SectionHeading.js";
import { NEWS_POSTS } from "../content/news.js";

const NewsPage = observer(() => {
  const { t, language } = useTranslation();
  return (
    <article className="landing-page">
      <SectionHeading eyebrow={t("landing.news.eyebrow")} title={t("landing.news.title")}
        body={t("landing.news.lead")} />
      <div className="landing-news-list">
        {NEWS_POSTS.map((post) => (
          <article key={post.slug}>
            <div className="landing-news-meta">
              <time dateTime={post.date}>{new Intl.DateTimeFormat(language, { dateStyle: "long" }).format(new Date(post.date))}</time>
              <span>{t(post.readingTimeKey)}</span>
            </div>
            <h2><Link to={`/news/${post.slug}`}>{t(post.titleKey)}</Link></h2>
            <p>{t(post.excerptKey)}</p>
            <Link className="landing-text-link" to={`/news/${post.slug}`}>{t("landing.news.read")}</Link>
          </article>
        ))}
      </div>
    </article>
  );
});

export default NewsPage;
